<div class="platform-blocked-overlay" *ngIf="isOpen">
  <div
    class="platform-blocked-card"
    [class.is-success]="isReleased"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="isReleased ? 'Acesso liberado' : 'Acesso bloqueado'"
  >
    <ng-container *ngIf="isReleased; else blockedContent">
      <div class="platform-blocked-icon">
        <img src="assets/shared/img/svg/icon-right.svg" alt="" />
      </div>

      <h2 class="platform-blocked-title">Tudo certo</h2>

      <p class="platform-blocked-message">
        Seu acesso foi liberado.
        <br />
        Redirecionando...
      </p>
    </ng-container>

    <ng-template #blockedContent>
      <div class="platform-blocked-icon" [class.has-background]="!hasVerified">
        <img
          [src]="hasVerified
            ? 'assets/shared/img/svg/icon-bloqueado.svg'
            : 'assets/shared/img/svg/first-icon-bloqueado.svg'"
          alt=""
        />
      </div>

      <h2 class="platform-blocked-title">Acesso bloqueado</h2>

      <p class="platform-blocked-message">
        {{ hasVerified
          ? getPendingMessage()
          : 'Sua fatura está em aberto. Após o pagamento, o acesso volta automaticamente.' }}
      </p>

      <button
        class="platform-blocked-check"
        type="button"
        [disabled]="isVerifying"
        (click)="checkAgain()"
      >
        <span class="platform-blocked-spinner" *ngIf="isVerifying"></span>
        {{ isVerifying
          ? 'Verificando...'
          : (hasVerified ? 'Verificar novamente' : 'Já paguei - verificar') }}
      </button>

      <button class="platform-blocked-logout" type="button" (click)="logout()">
        Sair
      </button>
    </ng-template>
  </div>
</div>
